import React from 'react'
import Menu from '../../components/Menu/Navbar'
import Header from '../../components/Header/header'
import Logo from '../../components/Logo/logo'
import Footer from '../../components/Footer/footer'
import BannerTeam from '../../components/BannerTeam/bannerteam'
import TeamImagenes from '../../components/TeamImagenes/teamimagenes'


const Team = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <BannerTeam />
      <TeamImagenes />
      <Footer />
      <></>
    </div>
  )
}

export default Team
